import { useCallback } from 'react'
import ModalSmallFilled from '../../../../../../../../../../baseComponents/ModalsLayouts/ModalSmallFilled'
import { ModalEditComponentProps } from '../../../../../../../../../../baseComponents/ModalsLayouts/types'
import useTwinTranslation from '../../../../../../../../../../utils/hooks/useTwinTranslation'
import { twinFetchPostJSON } from '../../../../../../../../../../utils/globals/data'
import useIsLoading from '../../../../../../../../../../utils/hooks/useIsLoading'

interface ModalReopenWorkSheetProps extends ModalReopenWorlSheetLogicProps {}

const ModalReopenWorkSheet: React.FC<ModalReopenWorkSheetProps> = ({ setOpened, onSubmit, allRowData }) => {
    const { t } = useTwinTranslation()
    const { handleOnAccept, loading } = useModalReopenWorlSheetLogic({ setOpened, onSubmit, allRowData })
    return (
        <ModalSmallFilled opened={true} setOpened={setOpened} onCancel={() => setOpened(null)} onAccept={handleOnAccept} translations={{
            title: t('sureReopenWorkSheet', '¿Seguro que quieres reabrir esta hoja de trabajo?'),
            subtitle: t('modificableOnceReopened', 'Podrás modificar los datos una vez reabierta'),
            buttonAccept: t('accept', 'Aceptar'),
        }} loading={loading} />
    )
}

interface ModalReopenWorlSheetLogicProps extends ModalEditComponentProps {}

const useModalReopenWorlSheetLogic = ({ allRowData, onSubmit }: ModalReopenWorlSheetLogicProps) => {
    const { startLoading, endLoading, loading } = useIsLoading()
    const handleOnAccept = useCallback(async () => {
        startLoading?.()
        const result = await twinFetchPostJSON('/api/app/order/sell/workSheet/updateWorkSheet', { ...allRowData || {} })
        if (result) {
            onSubmit?.(result, {})
        }
        endLoading?.()
    }, [startLoading, endLoading, onSubmit, allRowData])
    return { handleOnAccept, loading }
}


export default ModalReopenWorkSheet